import { reduce } from 'lodash-es'

import { Filder } from '@/project/documents/types'
import documentsService from '@/services/documents.service'
import { DESELECT_ALL_DOCUMENTS, GET_PAGINATED_DOCUMENTS } from '@/store/modules/documents/action_types'
import { GET_ROOM_STATS } from '@/store/modules/room/action_types'

import { DocumentsDeleteActionTypes } from './action_types'
import { DocumentsDeleteMutationTypes } from './mutation_types'



export const actions: StoreActions<DocumentsDeleteActionTypes, DocumentsDeleteMutationTypes> = {
  [DocumentsDeleteActionTypes.OPEN_DOCUMENTS_DELETION_DIALOG] ({ commit }, documents) {
    commit(DocumentsDeleteMutationTypes.SET_IS_OPEN, true)
    commit(DocumentsDeleteMutationTypes.SET_DOCUMENTS, documents)
  },
  [DocumentsDeleteActionTypes.CLOSE_DOCUMENTS_DELETION_DIALOG] ({ commit }) {
    commit(DocumentsDeleteMutationTypes.SET_LOADING, false)
    commit(DocumentsDeleteMutationTypes.SET_IS_OPEN, false)
  },
  async [DocumentsDeleteActionTypes.DELETE_FILDERS] ({ commit, state, rootState, rootGetters, dispatch }) {
    commit(DocumentsDeleteMutationTypes.SET_LOADING, true)

    const data = reduce(
      (state['documents'] as Array<Filder>),
      (result: { folderIds: number[]; fileIds: number[] }, document: Filder) => {
        if (document.type === 'folder') {
          result.folderIds.push(document.id)
        } else if (document.type === 'file') {
          result.fileIds.push(document.id)
        }

        return result
      },
      { folderIds: [] as number[], fileIds: [] as number[] },
    )
    // This is a TypeScript workaround to access the root room state
    const roomState = (rootState as any)['room']
    const { currentRoom } = roomState

    await documentsService.deleteFilders(currentRoom.mnemo, data)

    dispatch(`documents/${GET_PAGINATED_DOCUMENTS}`, undefined, { root: true })
    dispatch(`documents/${DESELECT_ALL_DOCUMENTS}`, null, { root: true })
    dispatch(DocumentsDeleteActionTypes.CLOSE_DOCUMENTS_DELETION_DIALOG)
    if (rootGetters['room/isDataRoom']) {
      dispatch(`room/${GET_ROOM_STATS}`, currentRoom.mnemo, { root: true })
    }
  },
}
